import type { ComponentProps } from 'react';
import { OwcTooltip } from '@one/react';

export type PocTooltipProps = ComponentProps<typeof OwcTooltip>;

export const PocTooltip: React.FC<PocTooltipProps> = (props) => <OwcTooltip {...props} />;
